var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { formatCurrency } from "@wrstudios/utils";
import { getMarkerColor } from "./utils";
import { Container, Image, Data, Street, CityStateZip, Price, Status } from "./styled/cluster-listing";
function ClusterListing(_a) {
    var id = _a.id, street = _a.street, city = _a.city, state = _a.state, zip = _a.zip, price = _a.price, photo = _a.photo, status = _a.status, _b = _a.statusValue, statusValue = _b === void 0 ? "" : _b, _c = _a.statusColor, statusColor = _c === void 0 ? "" : _c, statusBackgroundColor = _a.statusBackgroundColor, props = __rest(_a, ["id", "street", "city", "state", "zip", "price", "photo", "status", "statusValue", "statusColor", "statusBackgroundColor"]);
    var color = getMarkerColor({ statusValue: statusValue, color: statusColor });
    var cityStateZip = [[city, state].filter(Boolean).join(" "), zip]
        .filter(Boolean)
        .join(", ");
    return (React.createElement(Container, __assign({ key: id }, props),
        React.createElement(Image, { src: photo, alt: [street, cityStateZip].filter(Boolean).join(", ") }),
        React.createElement(Data, null,
            React.createElement(Street, null, street),
            React.createElement(CityStateZip, null, cityStateZip),
            React.createElement(Price, null,
                formatCurrency(price),
                React.createElement(Status, { style: { color: color, backgroundColor: statusBackgroundColor } }, status)))));
}
export default ClusterListing;
